







import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component
export default class Fdic extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop({ default: true })
  justifyCenter: boolean;
}
